import { useMemo } from 'react';
import { getTimeZones } from '@vvo/tzdb';

export const useTimezones = () => {
  return useMemo(() => {
    return getTimeZones()
      .map((tz) => ({
        label: tz.name,
        value: tz.name,
        // Country/city text only — deliberately excludes tz.group (the raw
        // IANA alias list, e.g. "America/Indiana/..."), so searching "india"
        // doesn't false-match US zones that merely contain that substring.
        searchText: `${tz.countryName} ${tz.alternativeName} ${tz.mainCities.join(' ')}`,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, []);
};
